import React from "react";
import { Box, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const MobileHeader = ({ title, onClose }) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        p: 1.5,
        borderBottom: "1px solid #f0f0f0",
        bgcolor: "#fff", // Garantindo o fundo branco
      }}
    >
      <Typography
        variant="h6"
        sx={{
          fontWeight: 600,
          fontSize: "1.1rem",
          color: "#263238",
          lineHeight: 1, // Melhora o alinhamento vertical com o ícone
        }}
      >
        {title}
      </Typography>

      <IconButton
        onClick={onClose}
        sx={{
          bgcolor: "#eceff1",
          "&:hover": { bgcolor: "#cfd8dc" },
          p: 0.5,
        }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>
  );
};

export default MobileHeader;
